export const CASHIER_TERMINAL_PROTOCOL = {
  PRIVATJSON: 'privatjson',
  SSI_JSON: 'ssi_json',
} as const;

export type CashierTerminalProtocol =
  (typeof CASHIER_TERMINAL_PROTOCOL)[keyof typeof CASHIER_TERMINAL_PROTOCOL];

export const CASHIER_TERMINAL_PROTOCOL_OPTIONS: {
  id: CashierTerminalProtocol;
  name: string;
}[] = [
  { id: CASHIER_TERMINAL_PROTOCOL.PRIVATJSON, name: 'PrivatJSON' },
  { id: CASHIER_TERMINAL_PROTOCOL.SSI_JSON, name: 'SSI JSON' },
];

export const DEFAULT_CASHIER_TERMINAL_PROTOCOL =
  CASHIER_TERMINAL_PROTOCOL.PRIVATJSON;
